import { render, staticRenderFns } from "./query-workitem.vue?vue&type=template&id=c38cbf66&scoped=true"
import script from "./query-workitem.vue?vue&type=script&lang=ts"
export * from "./query-workitem.vue?vue&type=script&lang=ts"
import style0 from "./query-workitem.vue?vue&type=style&index=0&id=c38cbf66&prod&lang=less&scoped=true"
import style1 from "./query-workitem.vue?vue&type=style&index=1&id=c38cbf66&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38cbf66",
  null
  
)

export default component.exports